import { OtherDocListComponent } from "../application/OtherDocListComponent.ts";
import { ApiOtherDocumentRepository } from "./ApiOtherDocumentRepository";
import { ApiWorkflowTemplateRepository } from "./ApiWorkflowTemplateRepository";
import { VueOtherDocumentListScreenData } from "./VueOtherDocumentListScreenData";
import { EntitiesListComponent } from "@/modules/entities/app/EntitiesListComponent.ts";
import { EntityTypeApiRepository, EntityInstanceApiRepository } from "@/modules/entities/infra/EntitiesApiRepositories.ts";
import { EntitiesListScreenData } from "@/modules/entities/domain/EntitiesListScreenData.ts";
import { EntityInstancesViewComponent } from "@/modules/entities/app/EntityInstancesViewComponent.ts";
import { EntityInstancesViewScreenData } from "@/modules/entities/domain/EntityInstancesViewScreenData.ts";

export class DocumentComponentsFactory {
    list_component: any;
    entities_list_component: any;
    // Registry of EntityInstancesViewComponent keyed by entity_type_uuid
    entity_instances_view_components: { [entity_type_uuid: string]: EntityInstancesViewComponent };

    constructor() {
        this.list_component = null;
        this.entities_list_component = null;
        this.entity_instances_view_components = {};
    }

    get_or_create_list_component() {
        if (!this.list_component) {
            this.list_component = new OtherDocListComponent(new ApiOtherDocumentRepository(), new VueOtherDocumentListScreenData(), new ApiWorkflowTemplateRepository());
        }
        return this.list_component;
    }

    get_list_component() {
        return this.list_component;
    }

    get_or_create_entities_list_component() {
        if (!this.entities_list_component) {
            this.entities_list_component = new EntitiesListComponent(new EntityTypeApiRepository(), new EntityInstanceApiRepository(), new EntitiesListScreenData());
        }
        return this.entities_list_component;
    }

    get_or_create_entity_instances_view_component(entity_type_uuid: string): EntityInstancesViewComponent {
        if (!this.entity_instances_view_components[entity_type_uuid]) {
            this.entity_instances_view_components[entity_type_uuid] = new EntityInstancesViewComponent(
                new EntityTypeApiRepository(),
                new EntityInstanceApiRepository(),
                new EntityInstancesViewScreenData()
            );
        }
        return this.entity_instances_view_components[entity_type_uuid];
    }
}
